export * from './Sup';



// WEBPACK FOOTER //
// ./src/Components/Superscript/StyledComponents/index.ts